import classNames from 'classnames'
import React from 'react'
import { dataColors } from './constants'

export type LegendCircleProps = {
  index: number
}

export const LegendCircle = ({ index }: LegendCircleProps) => {
  const dataColor = dataColors[index % dataColors.length]

  return (
    <div
      className={classNames(
        'flex justify-center items-center w-[24px] h-[24px] font-t-bold text-t-400 rounded-full',
        dataColor.bgColor,
        dataColor.whiteText ? 'text-neutral' : 'text-secondary-darker'
      )}
    >
      <span className="mb-2">{index + 1}</span>
    </div>
  )
}
